import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../components/Layoutthree";

import { SEO } from "../../components/seo";

import thumbnail1 from "../../images/Build-Query.png";
import thumbnail2 from "../../images/Custom-Report.png";
import thumbnail3 from "../../images/MRF-Quality-Assurance-Summary.png";
import thumbnail4 from "../../images/Claims-Summary-Reports.png";
import thumbnail9 from "../../images/Claims-Upload-&-Summary.png";
import thumbnail5 from "../../images/Standard-Reports.png";
import thumbnail6 from "../../images/MRF-Data-Overview.png";
import thumbnail7 from "../../images/Provider-Group-Use-Case.png";
import thumbnail8 from "../../images/Data-Aggregation.png";

const ContractRateExplorer = () => {
  //   const [currentName, setCurrentName] = useState("video0");
  //   const clickOfVideoHandler = (name) => {
  //     setCurrentName(name);
  //   };
  //   const videoList = [
  //     "video0",
  //     "video1",
  //     "video2",
  //     "video3",
  //     "video4",
  //     "video5",
  //     "vidoe6",
  //     "video7",
  //     "video8",
  //   ];

  //   const getVideoDetails = useCallback(
  //     (videoName) => {
  //       let url, title, thumbnail, duration, description;

  //       switch (videoName) {
  //         // case "video1":
  //         //   thumbnail = thumbnail2;
  //         //   url = "https://dh-website-bucket.s3.amazonaws.com/1688462740819";
  //         //   title = "Contract Rate Explorer - MRF Data Overview";
  //         //   duration = "Duration: 1:19";
  //         //   description =
  //         //     "A high-level overview of CRE and its initial dashboard, which includes the current payers included, overall MRF volumes, and national provider coverage.";
  //         //   break;
  //         case "video1":
  //           thumbnail = thumbnail5;
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/StandardReports.mp4";
  //           title = "Standard Reports ";
  //           duration = "2 Min | 9 Videos";
  //           description =
  //             "Overview of the standard reports that come pre-built within CRE.  These reports provide the ability to quickly illustrate provider rates by specialty, payer, state, or MSA, and continue to expand based on customer feedback and use cases.";
  //           break;
  //         case "video2":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/CustomReport.mp4";
  //           title = "Custom Report";
  //           description =
  //             "CRE Custom Report allows users to upload a list of codes and immediately get rate medians and percentiles across specialties, payers, states, or MSAs. ";
  //           duration = "2 Min | 9 Videos";
  //           thumbnail = thumbnail2;
  //           break;
  //         case "video3":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/BuildQuery.mp4";
  //           title = "Build Query ";
  //           thumbnail = thumbnail1;
  //           duration = "3 Min | 9 Videos";
  //           description =
  //             "CRE Query function allows users to run queries specific to a single code or billing NPI and get the specific MRF line item records, with the ability to filter by specialty, billing type, or even the provider's overall claim volume for that procedure code.";
  //           break;
  //         case "video4":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/DataAggregation.mp4";
  //           title = "Data Aggregation ";
  //           thumbnail = thumbnail8;
  //           duration = "2 Min | 9 Videos";
  //           description =
  //             "The data aggregation capability with CRE allows overall summarization of the MRF data by a specific metric, including looking at mean, 25th, or 75th percentile rates across different networks for a single-payer or even across multiple payers.";
  //           break;

  //         case "video5":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/ProviderGroupUseCase.mp4";
  //           title = "Provider Group Use Case";
  //           thumbnail = thumbnail7;
  //           duration = "3 Min | 9 Videos";
  //           description =
  //             "This provider group use case utilizes CRE's upload capability to compare one specific provider's contracted rates to other specific provider contract rates for a specific payer, allowing the user to quickly understand where there are revenue opportunities by procedure code.";
  //           break;
  //         case "video6":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/ClaimsUploadandSummary.mp4";
  //           title = "Claims Upload & Summary ";
  //           thumbnail = thumbnail9;
  //           duration = "4 Min | 9 Videos";
  //           description =
  //             "CRE's Claim Report allows users to upload a claim file, possibly a single employer group, choose specific carrier networks as the primary network, and add additional networks to compare against the primary network. Users can quickly assess a group's claim experience within a different network.";
  //           break;

  //         case "video7":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/ClaimsSummaryandReports.mp4";
  //           title = "Claims Summary Reports ";
  //           thumbnail = thumbnail4;
  //           duration = "2 Min | 9 Videos";
  //           description =
  //             " CRE's Claim Report summary reports provide immediate results for users to assess, and full file comparison results across networks.  This data can be quickly exported for users to easily analyze outside of CRE or import into their own application.";
  //           break;
  //         case "video8":
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/MRFQualityAssuranceSummary.mp4";
  //           title = "MRF Quality Assurance Summary ";
  //           thumbnail = thumbnail3;
  //           duration = "2 Min | 9 Videos";
  //           description =
  //             " Quality is key when it comes to Payer MRF data.  These files are large and complex.  CRE provides the ability to quickly navigate to specific MRF metrics to ensure each file includes expected metrics, including a number of providers by state, and comparing those counts from MRF to MRF, making sure the files being uploaded are complete.";
  //           break;

  //         default:
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/MRFDataOverview.mp4";
  //           thumbnail = thumbnail6;
  //           url =
  //             "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/MRFDataOverview.mp4";
  //           title = "MRF Data Overview";
  //           duration = "2 Min | 9 Videos";
  //           description =
  //             "A high-level overview of CRE and its initial dashboard, which includes the current payers included, overall MRF volumes, and national provider coverage.";

  //           break;
  //       }

  //       return { url, title, thumbnail, duration, description };
  //     },
  //     [currentName]
  //   );

  return (
    <Layout>
      <div className="solutions">
        <div className="services">
          <div className="container-fluid ">
            <div className="d-flex flex-column justify-content-center align-content-center">
              <div className="services-top-info container margin-0">
                <h1>Media</h1>
              </div>

              <section
                className="container media-section bg-blue"
                style={{ marginTop: "10px !important" }}
              >
                <div className="row video-section">
                  <div className="col-lg-12 col-12 Webinar mb-3">
                    <h2 className="webinar-heading">
                      Contract Rate Explorer - Powered by MRF Insights
                    </h2>
                  </div>

                  <div className="col-lg-9 col-12  webinar-media-big">
                    <video
                      controls
                      poster={thumbnail3}
                      muted
                      autoplay
                      key="MRF Quality Assurance Summary"
                    >
                      <source
                        src={
                          "https://dh-website-bucket.s3.amazonaws.com/WebinarFinal/MRFQualityAssuranceSummary.mp4"
                        }
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <h4 className=" mt-4">
                      Contract Rate Explorer - MRF Quality Assurance Summary
                    </h4>
                    <p className="time-media-page">2 Min | 9 Videos</p>
                    <p className="desc-media-page">
                      Quality is key when it comes to Payer MRF data. These
                      files are large and complex. CRE provides the ability to
                      quickly navigate to specific MRF metrics to ensure each
                      file includes expected metrics, including a number of
                      providers by state, and comparing those counts from MRF to
                      MRF, making sure the files being uploaded are complete.
                    </p>
                  </div>
                  <div className="col-lg-3 col-12 suggested-videos-media">
                    <h5
                      style={{
                        color: "#134369",
                        marginBottom: "0",
                        fontWeight: "bold",
                      }}
                    >
                      9 Videos Series
                    </h5>

                    <p
                      style={{
                        marginBottom: "0",
                      }}
                    >
                      Scroll down to browse more
                    </p>
                    <a href="/video/mrf-data-overview">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail6}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          MRF Data Overview
                        </p>
                      </div>
                    </a>
                    <a href="/video/standard-reports">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail5}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Standard Reports
                        </p>
                      </div>
                    </a>

                    <a href="/video/custom-reports">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail2}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Custom Report
                        </p>
                      </div>
                    </a>
                    <a href="/video/build-query">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail1}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Build Query
                        </p>
                      </div>
                    </a>
                    <a href="/video/data-aggregration">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail8}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Data Aggregation
                        </p>
                      </div>
                    </a>
                    <a href="/video/provider-group-use-case">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail7}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Provider Group Use Case
                        </p>
                      </div>
                    </a>

                    <a href="/video/claims-upload-and-summary">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail9}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Claims Upload & Summary
                        </p>
                      </div>
                    </a>
                    <a href="/video/claims-summary-reports">
                      <div className="col-lg-12 col-12 media-video">
                        <video poster={thumbnail4}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          Claims Summary Reports
                        </p>
                      </div>
                    </a>
                    <a href="/video/mrf-quality-assurance-summary">
                      <div className="col-lg-12 col-12 media-video now-playing">
                        <p className="now-playing-buttom">Now Playing</p>
                        <video poster={thumbnail3}>
                          Your browser does not support the video tag.
                        </video>
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            margin: "0px",
                          }}
                        >
                          MRF Quality Assurance Summary
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContractRateExplorer;

export const Head = () => (
  <SEO
    title=" MRF Quality Assurance Summary
"
    description=" Deerhold revolutionizes healthcare data accessibility through Contract Rate Explorer. Contact sales@deerhold.com to leverage Deerhold's innovative approach."
    keywords="MRF Data Overview, Provider Group Use Case, Claims Summary, Payer MRF data, Machine Readable Files, Transparency in Coverage Rule, Insights on Provider Rates, Insights on Healthcare, Transparency in Coverage Rule, Deerhold Media, Healthcare Transparency, Transparency in Coverage, Healthcare IT Solutions, Health Data Analytics, Healthcare Solution, Contract Rate Explorer"
    pathname="/MRF"
    image="/MRFQualityOG.jpg"
  />
);
